import React from 'react'
import { connect } from 'react-redux'
import { Dispatch } from 'redux'
import { toggle } from '../actions/ui'
import { closeErrorMessage, uploadFailed } from '../actions/upload'
import Alert from '../components/base/Alert'
import { StoreState } from '../reducer/types'

export type ErrorMessagesProps = {
  alertFileSize: boolean
  alertFileType: boolean
  maxFileSize: number
  uploadError: boolean
  dismiss: (...args: any[]) => any
}
export const ErrorMessages: React.FunctionComponent<ErrorMessagesProps> = ({
  alertFileSize,
  alertFileType,
  maxFileSize,
  uploadError,
  dismiss,
}) => {
  let msg
  let dismissKey: string
  if (alertFileType) {
    msg = "Sorry we don't support this file type. Please try another."
    dismissKey = 'alertFileType'
  } else if (alertFileSize) {
    msg = `We have a file maximum of ${maxFileSize}MB. Please try again.`
    dismissKey = 'alertFileSize'
  } else if (uploadError) {
    msg = "Hmm, that didn't work."
    dismissKey = 'error'
  }
  if (msg) {
    return (
      <Alert
        type="danger"
        message={msg}
        onClose={() => dismiss(dismissKey)}
        error={uploadError || alertFileSize || alertFileType}
      />
    )
  }
  return null
}
const mapStateToProps = (state: StoreState) => ({
  uploadError: state.upload.error,
  alertFileSize: state.ui.alertFileSize,
  alertFileType: state.ui.alertFileType,
  maxFileSize: state.app.upload ? state.app.upload.filesize.max / 1024 / 1024 : 0,
})
const mapDispatchToProps = (dispatch: Dispatch) => ({
  dismiss: (key: string) => {
    dispatch(toggle(key, false))
    dispatch(uploadFailed())
    dispatch(closeErrorMessage())
  },
})
export default connect(mapStateToProps, mapDispatchToProps)(ErrorMessages)
